import { lazy } from 'react';

/** Загружает страницу конфигурации Telegram по требованию */
export const TelegramSettingsFormPageAsync = lazy(() => import('./TelegramSettingsForm/TelegramSettingsFormPage'));
